import * as client from './baseClient';

export const getBranch = (branchId) => client.get(`/api/branches/${branchId}`);
export const getBranchForUser = (userId) =>
  client.get(`/api/branches/for-user/${userId}`);

export const getBranchById = (branchId) =>
  client.get(`/api/branches/${branchId}`);

export const getAllBranches = (loggedInUserId) =>
  client.get('/api/branches', undefined, loggedInUserId);

export const createBranch = (branch, loggedInUserId) =>
  client.post('/api/branches', branch, undefined, loggedInUserId);

export const updateBranch = (branch, loggedInUserId) =>
  client.put(`/api/branches/${branch.id}`, branch, undefined, loggedInUserId);
